import api from '@/api/index';

const namespaced = true;

const state = {
  quarterlyInspections: [],
  quarterlyInspectionFiles: {},
  fileExport: {}
};

const getters = {
  quarterlyInspections: (state) => state.quarterlyInspections,
  quarterlyInspectionFiles: (state) => state.quarterlyInspectionFiles,
  fileExport: (state) => state.fileExport
};

const mutations = {
  SET_QUARTERLY_INSPECTIONS: (state, payload) => {
    state.quarterlyInspections = payload;
  },
  SET_QUARTERLY_INSPECTION_FILES: (state, payload) => {
    state.quarterlyInspectionFiles = payload;
  },
  SET_FILE_EXPORT: (state, payload) => {
    state.fileExport = payload;
  }
};

const actions = {
  async fetchQuarterlyInspections({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const params = {
        search: filterConfig.search,
        ...payload
      }
      const { data } = await api.getQuarterlyInspections(params);

      if (data.error) {
        commit('SET_QUARTERLY_INSPECTIONS', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_QUARTERLY_INSPECTIONS', data)
      commit('Table/SET_TOTAL_DATA', data.total ?? 0, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
      return data
    } catch (error) {
      throw error.data;
    }
  },
  async fetchQuarterlyInspectionDetail(_, id) {
    try {
      const { data } = await api.getQuarterlyInspectionDetail(id)
      
      return data
    } catch (error) {
      throw error
    }
  },
  async postQuarterlyInspection(_, payload) {
    try {
      await api.postQuarterlyInspection(payload);
    } catch (error) {
      throw error.data;
    }
  },
  async putQuarterlyInspection(_, payload) {
    try {
      await api.putQuarterlyInspection(payload.id, payload.form);
    } catch (error) {
      throw error.data;
    }
  },
  async deleteQuarterlyInspection(_, payload) {
    try {
      await api.deleteQuarterlyInspection(payload);
    } catch (error) {
      throw error.data;
    }
  },
  async getQuarterlyInspectionStatus() {
    try {
      const data = await api.getQuarterlyInspectionStatus();
      return data
    } catch (error) {
      throw error.data;
    }
  },
  async getQuarterlyInspectionItems() {
    try {
      const data = await api.getQuarterlyInspectionItems();
      return data
    } catch (error) {
      throw error.data;
    }
  },
  async downloadQuarterlyInspection({ commit }, payload) {
    try {
      const data = await api.downloadFileQuarterInspection(payload)
      if (data) {
        commit('SET_QUARTERLY_INSPECTION_FILES', data)
      }
    } catch (error) {
      throw error.data;
    }
  },
  async exportQuarterlyInspection({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const data = await api.exportQuarterlyInspection({
        search: filterConfig.search,
        ...payload})
      if (data) {
        commit('SET_FILE_EXPORT', data)
      }
    } catch (error) {
      throw error.data;
    }
  },
  async postQuarterlyInspectionSendEmail(_, payload) {
    try {
      const { data } = await api.postQuarterlyInspectionSendEmail(payload)
      if (data.error) {
        return
      }
      return data.data
    } catch (error) {
      throw error
    }
  },
  resetFile({ commit }) {
    commit('SET_QUARTERLY_INSPECTION_FILES', {})
  },
  resetFileExport({ commit }) {
    commit('SET_FILE_EXPORT', {})
  }
};

export default { namespaced, state, getters, mutations, actions };
